import moment from "moment";

export default (
  searchCriteria,
  client_oid,
  searchRelatedIdentities,
  isImdmClient
) => {
  if (!searchCriteria) return {};
  return searchCriteria.reduce((data, criteria) => {
    if (criteria.key === "given0" || criteria.key === "given1") {
      if (data.names) {
        if (data.names[0].given) {
          data.names = [
            {
              ...data.names[0]
            },
            {
              given: criteria.value
            }
          ];
        } else {
          data.names = [
            {
              ...data.names[0],
              given: criteria.value
            }
          ];
        }
      } else {
        data.names = [
          {
            given: criteria.value
          }
        ];
      }
    } else if (criteria.key === "family" || criteria.key === "middle") {
      if (data.names) {
        if (data.names[1]) {
          data.names = [
            {
              ...data.names[0],
              [criteria.key]: criteria.value
            },
            {
              ...data.names[1]
            }
          ];
        } else {
          data.names = [
            {
              ...data.names[0],
              [criteria.key]: criteria.value
            }
          ];
        }
      } else {
        data.names = [
          {
            [criteria.key]: criteria.value
          }
        ];
      }
    } else if (
      criteria.key === "city" ||
      criteria.key === "state" ||
      criteria.key === "country" ||
      criteria.key === "postalCode" ||
      criteria.key === "streetAddress"
    ) {
      data.addresses = [
        {
          ...(data.addresses ? data.addresses[0] : null),
          [criteria.key]: criteria.value
        }
      ];
    } else if (criteria.key === "system" || criteria.key === "value") {
      let key = criteria.key;
      if (criteria.key === "source_code") {
        key = "system";
      }
      if (criteria.key === "record_id") {
        key = "value";
      }
      data.ids = [
        {
          ...(data.ids ? data.ids[0] : null),
          [key]: criteria.value
        }
      ];
    } else if (criteria.key === "source_code") {
      data.sourceId = criteria.value;
    } else if (criteria.key === "record_id") {
      data.ids = [
        {
          ...(data.ids ? data.ids[0] : null),
          value: criteria.value
        }
      ];
    } else if (criteria.key === "gender") {
      data.gender = criteria.value.toLocaleLowerCase();
    } else if (criteria.key === "birthTime") {
      data.birthTime = moment(criteria.value).format("YYYYMMDD");
    } else if (criteria.key === "golden_id") {
      if (searchRelatedIdentities) {
        data.link = [
          {
            other: {
              reference: criteria.value
            },
            type: "seealso"
          }
        ];
      } else {
        data.ids = [
          {
            ...(data.ids ? data.ids[0] : null),
            system: client_oid,
            value: criteria.value
          }
        ];
      }
    } else if (
      criteria.key === "ssn" ||
      criteria.key === "email" ||
      criteria.key === "telecom" ||
      criteria.key === "mbi" ||
      criteria.key === "hicn"
    ) {
      let key = criteria.key;
      data[key] = criteria.value;
    } else if (
      criteria.key === "policyNum" ||
      criteria.key === "subscriberID"
    ) {
      let value = data.policySubscriber
        ? JSON.parse(data.policySubscriber)
        : {};
      value[criteria.key] = criteria.value;
      data.policySubscriber = JSON.stringify(value);
    }
    return data;
  }, {});
};
